var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEMO_COMMUNICATION_LABEL_IDS, getDemoActivityLabelName } from '@web/lib/demo/data/labels';
import { ItemsByType } from '@workalizer/shared';
import { diffComparisonType } from '@workalizer/shared/types';
import { getPercentageDiff } from '@workalizer/shared/utils';
var comparisonCountFromDiffString = function (current, diffString) {
    var pct = Number(diffString.replace('%', '').replace('+', ''));
    if (pct === 0) {
        return current;
    }
    return Math.round(current / (1 + pct / 100));
};
var buildLabelDiffs = function (counts, previousDiffStrings, teamDiffStrings) {
    var previousCounts = {
        documents: comparisonCountFromDiffString(counts.documents, previousDiffStrings.documents),
        meetings: comparisonCountFromDiffString(counts.meetings, previousDiffStrings.meetings),
        calendarEvents: comparisonCountFromDiffString(counts.calendarEvents, previousDiffStrings.calendarEvents),
        chatRooms: comparisonCountFromDiffString(counts.chatRooms, previousDiffStrings.chatRooms)
    };
    var teamAverageDiff = function (current, diffString) {
        var pct = Number(diffString.replace('%', '').replace('+', ''));
        var teamAvg = pct === 0 ? current : current / (1 + pct / 100);
        var diff = getPercentageDiff(teamAvg, current, {
            comparisonType: diffComparisonType.teamAverage
        });
        var displayTeamAvg = Math.round(teamAvg);
        return __assign(__assign({}, diff), { comparisonValueDisplay: String(displayTeamAvg) });
    };
    return {
        previousPeriod: {
            documents: getPercentageDiff(previousCounts.documents, counts.documents),
            meetings: getPercentageDiff(previousCounts.meetings, counts.meetings),
            calendarEvents: getPercentageDiff(previousCounts.calendarEvents, counts.calendarEvents),
            chatRooms: getPercentageDiff(previousCounts.chatRooms, counts.chatRooms)
        },
        teamAverage: {
            documents: teamAverageDiff(counts.documents, teamDiffStrings.documents),
            meetings: teamAverageDiff(counts.meetings, teamDiffStrings.meetings),
            calendarEvents: teamAverageDiff(counts.calendarEvents, teamDiffStrings.calendarEvents),
            chatRooms: teamAverageDiff(counts.chatRooms, teamDiffStrings.chatRooms)
        }
    };
};
var buildByTypeItem = function (label, created, previousPeriod, teamAverage) { return ({
    label: label,
    created: created,
    previousPeriod: {
        value: previousPeriod,
        diff: getPercentageDiff(previousPeriod, created)
    },
    teamAverage: {
        value: teamAverage,
        diff: getPercentageDiff(teamAverage, created, {
            comparisonType: diffComparisonType.teamAverage
        })
    }
}); };
var createdItemsByLabelRows = [
    {
        counts: { documents: 3, meetings: 2, calendarEvents: 1, chatRooms: 4 },
        previousDiffStrings: {
            documents: '+50%',
            meetings: '+100%',
            calendarEvents: '0%',
            chatRooms: '+33%'
        },
        teamDiffStrings: {
            documents: '+20%',
            meetings: '-15%',
            calendarEvents: '+10%',
            chatRooms: '+25%'
        }
    },
    {
        counts: { documents: 5, meetings: 1, calendarEvents: 2, chatRooms: 2 },
        previousDiffStrings: {
            documents: '+25%',
            meetings: '-50%',
            calendarEvents: '+100%',
            chatRooms: '+100%'
        },
        teamDiffStrings: {
            documents: '+40%',
            meetings: '-30%',
            calendarEvents: '+20%',
            chatRooms: '-10%'
        }
    },
    {
        counts: { documents: 2, meetings: 3, calendarEvents: 1, chatRooms: 1 },
        previousDiffStrings: {
            documents: '+100%',
            meetings: '+50%',
            calendarEvents: '0%',
            chatRooms: '0%'
        },
        teamDiffStrings: {
            documents: '-25%',
            meetings: '+35%',
            calendarEvents: '-15%',
            chatRooms: '-20%'
        }
    }
];
export var createdItemsByType = function () {
    return {
        byType: [
            buildByTypeItem(ItemsByType.DOCUMENTS, 12, 8, 15),
            buildByTypeItem(ItemsByType.MEETINGS, 5, 3, 7),
            buildByTypeItem(ItemsByType.CALENDAR_EVENTS, 8, 6, 11),
            buildByTypeItem(ItemsByType.CHAT_ROOMS, 15, 12, 18)
        ],
        byLabel: DEMO_COMMUNICATION_LABEL_IDS.slice(0, 3).map(function (labelId, index) {
            var row = createdItemsByLabelRows[index];
            return __assign(__assign({ labelName: getDemoActivityLabelName(labelId) }, row.counts), buildLabelDiffs(row.counts, row.previousDiffStrings, row.teamDiffStrings));
        })
    };
};
